import React, { useState, useEffect } from "react";

import { FaCheckCircle } from "react-icons/fa";

const Satisfaction = () => {
   const [isLargeScreen, setIsLargeScreen] = useState(() =>
              window.matchMedia("(min-width: 1280px)").matches
            );
             useEffect(() => {
                const mediaQuery = window.matchMedia("(min-width: 1280px)");
                const handleChange = (e) => setIsLargeScreen(e.matches);
                mediaQuery.addEventListener("change", handleChange);
            
                return () => {
                  mediaQuery.removeEventListener("change", handleChange);
                };
              }, []);
  const points = [
    {
      text: "Engage patients in the marvels they achieve every day. Quantify progress clearly, share with patients, and motivate them.",
      icon: <FaCheckCircle color="#FFFFFF" />, 
    },
    {
      text: "Help patients achieve 100% health with an engaging and scientific rehabilitation process, using feedback-based rehabilitation plans.",
      icon: <FaCheckCircle color="#FFFFFF" />, 
    },
    {
      text: "Focus on the motion, or extend the hands of help for assistance, because GoNeo can now measure everything with its hands-free mode.",
      icon: <FaCheckCircle color="#FFFFFF" />, 
    },
  ];

  return (
    <>{isLargeScreen&&
      <div className="d-flex flex-column bg-gray-light justify-content-evenly m-0 upy-3">
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold ufs-7 m-0">INCREASE PATIENT SATISFACTION</p>
      </div>
      <div className="upy-10 upx-10 m-0 uh-120 uw-315 bg-gray-light">
        <div className="d-flex position-relative">
          <ul
            className="bg-gray-light"
            style={{
              listStyle: "none", 
            }}
          >
            {points.map((point, index) => (
              <li
                key={index}
                className="d-flex align-items-center fw-bold ufs-5 text-gray umy-8 upx-8 upy-5 br-5 box-shadow"
                style={{
                  position: "relative", 
                  overflow: "hidden", 
                }}
              >
                {/* Colored Background */}
                <div className="position-absolute top-0 start-0 bg-dark-blue uw-25 " 
                  style={{ 
                     height: "100%",  
                  }}
                ></div>

                {/* Icon */}
                <span className=" d-flex justify-content-center align-items-center uw-12 uh-15 ufs-10 m-0 upr-3 z-1 ">
                  {point.icon}
                </span>

                {/* Text */}
                <span className=" upl-12 z-2">
                  {point.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    }{!isLargeScreen&&
      <div className="d-flex flex-column bg-gray-light justify-content-evenly m-0 upy-3">
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold ufs-14 m-0">INCREASE PATIENT SATISFACTION</p>
      </div>
      <div className="up-10 m-0  uw-315 bg-gray-light">
        <div className="d-flex position-relative m-0 p-0">
          <ul
            className="bg-gray-light m-0 p-0"
            style={{
              listStyle: "none", 
            }}
          >
            {points.map((point, index) => (
              <li
                key={index}
                className="d-flex align-items-center fw-bold ufs-14 text-gray mx-0 umy-8 upx-8 upy-5 br-5 box-shadow"
                style={{
                  position: "relative", 
                  overflow: "hidden", 
                }}
              >
                 <div className="position-absolute top-0 start-0 bg-dark-blue uw-10 " 
                  style={{ 
                     height: "100%",  
                  }}
                ></div>
                {/* Text */}
                <span className=" upl-12 z-2">
                  {point.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    }</>
   
  );
};

export default Satisfaction;
